import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20" aria-label="行动号召">
      <div className="w-full px-4 md:px-8 max-w-[1400px] mx-auto">
        <div className="flex flex-col items-center text-center">
          <div className="w-full max-w-3xl mx-auto rounded-2xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20film%20grain%20texture%20overlay%20on%20warm%20abstract%20composition%2C%20soft%20vintage%20cinematic%20mood%2C%20golden%20hour%20light%20leaking%20through%2C%20dreamy%20atmosphere%2C%20professional%20editorial%20photography%2C%20neutral%20cream%20and%20beige%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=cta-media-001&orientation=landscape"
              alt="91免费平台体验"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-relaxed max-w-2xl">
            <span className="font-light text-foreground-400">不想错过</span> 每一个热点
            <br />
            <span className="font-heading italic font-bold text-primary-500">立即加入</span> 百万吃瓜大军
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg">
            每日更新最新娱乐八卦，覆盖明星动态、网红爆料、热门事件追踪
          </p>

          <Link
            to="/category/daily-update"
            className="mt-10 inline-flex items-center gap-2 px-12 py-4 bg-foreground-950 text-background-50 text-sm md:text-base font-semibold rounded-full transition-all duration-300 hover:bg-foreground-800 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            立即开始吃瓜
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}